
import { memo, useCallback } from "react";
import { BsX } from "react-icons/bs";
import { CiCircleInfo, CiCircleQuestion } from "react-icons/ci";
import { IoMdCheckmarkCircleOutline } from "react-icons/io";
import ReactModal from "react-modal";
import { color_black, color_black_ultra_light, color_grey_dark, color_red_default, color_white } from "../../constants/colors";
import sadIcon from "../../images/sad-icon.svg";
import { useWindowDimensions } from "../../utils";
import { OnestNormalSmall, OnestSemiBoldBig } from "../styled/TextComponents";
import { useI18n } from "../../i18n/I18nProvider";

const ModalQuestionTwoAnswers = memo(({ type, h2, p, isOpen, onClose, onAnswer, yesText, noText, isButtonRevers = false }) => {

    const { t } = useI18n();
    const { height: screenHeight, width: screenWidth } = useWindowDimensions();

    const handleClose = useCallback(() => {
        onClose(false);
    }, [onClose]);

    const handleYes = useCallback(() => {
        onAnswer(true);
    }, [onAnswer]);

    const handleNo = useCallback(() => {
        onAnswer(false);
    }, [onAnswer]);

    return (
        <ReactModal
            isOpen={isOpen}
            onRequestClose={handleClose}
            //onAfterOpen={onAfterOpen}
            style={{
                content: {
                    backgroundColor: color_white,
                    borderRadius: "16px",
                    width: screenWidth > 550 ? "360px" : screenWidth - 150,
                    height: "255px",
                    margin: "auto",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-around",
                    alignItems: "center",
                    gap: "0px",
                    inset: screenWidth > 460 ? "40px" : `calc(50vw - ${screenWidth - 150 / 2}px)`
                },
                overlay: {
                    backgroundColor: "rgba(0, 0, 0, 0.65)",
                    backdropFilter: "blur(8px)",
                    overflow: "hidden",
                    zIndex: 1000,
                },

            }}
        >
            <div
                style={{
                    position: "absolute",
                    top: 20,
                    right: 20,
                    cursor: "pointer",
                    zIndex: 1000
                }}
                onClick={handleClose}
            >
                <BsX
                    style={{
                        fontSize: 30,
                        color: color_grey_dark
                    }}
                />
            </div>
            {type === "success" &&
                <IoMdCheckmarkCircleOutline size={25} />
            }
            {type === "error" &&
                <CiCircleInfo size={28} />
            }
            {type === "alert" && !(screenWidth >= 320 && screenWidth <= 450) &&
                <img src={sadIcon} alt="sad" style={{ width: 20, height: 20 }} />
            }
            {type === "question" &&
                <CiCircleQuestion size={40} />
            }
            <OnestSemiBoldBig style={{ fontSize: "24px", textAlign: "center", color: color_black, margin: 2 }}>{t(h2)}</OnestSemiBoldBig>
            <OnestNormalSmall style={{ fontSize: "16px", textAlign: "center", color: color_black, }}>{t(p)}</OnestNormalSmall>

            <div style={{
                display: "flex",
                flexDirection: isButtonRevers ? "column-reverse" : "column",
                justifyContent: "center",
                alignItems: "center",
                gap: 10,
                marginTop: "20px",

            }}>

                <button
                    style={{
                        backgroundColor: isButtonRevers ? color_white : color_red_default,
                        color: isButtonRevers ? color_grey_dark : color_white,
                        borderRadius: "16px",
                        border: isButtonRevers ? "1px solid " + color_grey_dark : "none",
                        padding: "10px 20px",
                        cursor: "pointer",
                        fontSize: "16px",
                        fontWeight: "normal",
                        minWidth: 224,
                        width: 'auto',
                        height: 40,
                        fontFamily: "Onest",
                        lineHeight: "normal",
                        letterSpacing: "0%",
                    }}
                    onClick={handleYes}
                >
                    {yesText ? t(yesText) : t("ДА")}
                </button>
                <button
                    style={{
                        backgroundColor: isButtonRevers ? color_red_default : color_white,
                        color: isButtonRevers ? color_white : color_black_ultra_light,
                        borderRadius: "16px",
                        border: isButtonRevers ? "none" : "1px solid " + color_grey_dark,
                        padding: "10px 20px",
                        cursor: "pointer",
                        fontSize: "16px",
                        fontWeight: "normal",
                        minWidth: 224,
                        width: 'auto',
                        height: 40,
                        fontFamily: "Onest",
                        lineHeight: "normal",
                        letterSpacing: "0%",
                    }}
                    onClick={handleNo}
                >
                    {noText ? t(noText) : t("НЕТ")}
                </button>
            </div>
        </ReactModal>
    )
})

export default ModalQuestionTwoAnswers